import { ThemeOptions } from '@mui/material/styles';

declare module '@mui/material/styles' {
  interface Palette {
    dustyRose: Palette['primary'];
    participating: Palette['primary'];
    breadcrumb: Palette['primary'];
    selection: Palette['primary'];
  }
  interface PaletteOptions {
    dustyRose?: PaletteOptions['primary'];
    participating?: PaletteOptions['primary'];
    breadcrumb?: PaletteOptions['primary'];
    selection?: PaletteOptions['primary'];
  }
}

export const themeOptions: ThemeOptions = {
  palette: {
    primary: {
      main: '#004365',
    },
    secondary: {
      main: '#A16763',
    },
    dustyRose: {
      main: '#A16763',
      contrastText: '#FFFFFF',
    },
    participating: {
      main: '#D7D7D7',
      contrastText: '#000000',
    },
    breadcrumb: {
      main: '#FBF6F5',
    },
    selection: {
      main: '#B8D4DF',
    },
    background: {
      default: '#FFFFFF',
    },
    text: {
      primary: '#000000',
    },
  },
  typography: {
    fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
    h1: {
      fontFamily: '"Bitter", "Georgia", serif',
      fontWeight: 500,
      color: '#004365',
    },
    h2: {
      fontFamily: '"Bitter", "Georgia", serif',
      fontWeight: 500,
      color: '#004365',
    },
    h3: {
      fontFamily: '"Bitter", "Georgia", serif',
      fontWeight: 500,
      color: '#004365',
    },
    h4: {
      fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
      fontWeight: 700,
      color: '#004365',
    },
    h5: {
      fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
      fontWeight: 700,
      color: '#004365',
    },
    h6: {
      fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
      fontWeight: 700,
      color: '#004365',
    },
    button: {
      fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
      fontWeight: 700,
      textTransform: 'none',
    },
  },
  components: {
    MuiLink: {
      defaultProps: {
        color: 'primary.main',
      },
    },
  },
};
